import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Unit(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (this.filteringService.unit().length < 1) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  if (!listing.unit) {
    return false;
  }

  // Determine if the listing matches the filter.
  const _value = this.filteringService.unit().map((v) => parseInt(v, 10));
  if (!_value.includes(listing.unit)) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
